import React, { Component } from "react";
import { Editor } from "react-draft-wysiwyg";
import BounceLoader from 'react-spinners/BounceLoader'
import BeatLoader from "react-spinners/BeatLoader";

import LoadingOverlay from '../common/Loader';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { api } from '../Services/index';
import { withRouter } from "react-router-dom";
import htmlToDraft from 'html-to-draftjs';
import Toaster from '../components/Toaster';
import getRefreshToken from '../Services/token';
var obj = require('lodash');
const loaderStyle = {
    color: '#f3f3f3',

};
class AssociateNotes extends Component {


    constructor(props, context) {
        super(props);
        this.state = {
            notes: null,
            notesedit: '',
            dcgId: null

        }
    }

    componentDidMount() {
        if (this.props && this.props.dcgId) {
            this.getNotes(this.props.dcgId);
        }
      
    }
    componentWillReceiveProps(nextProps) {
        this.getNotes(nextProps.dcgId);
    }

    getNotes = (dcgId) => {
        this.setState({ spinnerLoading: true });
        api.getNotes(dcgId)
            .then(result => {
                if (result && result.response && result.response.status == 401) {
                    this.getrefreshtoken(dcgId);
                    return;
                }
                if (result && result.data && result.data.notes) {
                    this.state.notesedit = result.data.notes;
                    let _this = this;
                    setTimeout(() => {
                        $('#hiddennotes').modal('show')
                        _this.setState({ spinnerLoading: false });
                    }, 800);
                }
                else {
                    let _this = this;
                    setTimeout(() => {
                        _this.setState({ spinnerLoading: false })
                        _this.toggleToaster('No associate notes available for the DCG.', 'warn')
                    }, 800);
                }
            });
    }
    getrefreshtoken(actionPayload) {
        getRefreshToken()
            .then(res => {
                this.getNotes(actionPayload);
            })
            .catch(err => {
                this.props.history.push('/login');
            })
    }

    toggleToaster(message, type) {
        this.setState({
            toasterMessage: message,
            toasterType: type
        })

        setTimeout(() => {
            this.setState({
                toasterMessage: null,
                toasterType: undefined
            })
        }, 2000);
    }
    doneFN = () => {
        this.props.hiddenNotesModal(false);
    }
      render() {
        const { editorState } = this.state;
          return (
              <div>
                
                  { this.state.toasterMessage ? <Toaster message={this.state.toasterMessage} toasterType={this.state.toasterType} /> : null}
                  <LoadingOverlay active={this.state.spinnerLoading} spinner={<BeatLoader color={'#338bc1'}  />} className={loaderStyle} >
                         {(<div className="modal mt-5" id="hiddennotes" style={{ maxHeight: 600 }}>
                                      <div className="modal-dialog modal-lg">
                                      <div className="modal-content">

                                          <div className="modal-header">
                                              <h4 className="modal-title">Notes to Self: Associate Use Only</h4>
                                              <button type="button" onClick={() => { this.doneFN() }} className="close" data-dismiss="modal" aria-label="Close">
                                                  <span>&times;</span>
                                              </button>
                                          </div>
                                  <div className="modal-body row" >
                                      <div className="col-md-12" dangerouslySetInnerHTML={{ __html: this.state.notesedit }}>
                                      </div>
                                  </div>

                                          <div className="modal-footer">
                                              <button type="button" onClick={() => { this.doneFN() }} data-dismiss="modal" className="btn btn-primary" >Close</button>
                                          </div>
                                      </div>
                                  </div>
                          </div >
                  
                  )}
                  </LoadingOverlay>
              </div>
          );
    }
}
export default withRouter(AssociateNotes);